<template>
  <div class="pills">
    <swiper
      :modules="modules"
      :slides-per-view="slidesPerView"
      :space-between="15"
      navigation
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      @reachEnd="onSwiperReachEnd"
    >
      <swiper-slide v-for="(childs, i) in cat.childs" v-bind:key="i">
        <button-pill
          class="btn btn-outline-pill"
          v-bind:class="{ active: selectedChild === i }"
          @click="selectChild(i)"
        >
          {{ childs.name }}
        </button-pill>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import ButtonPill from "@/components/generic/ButtonPill.vue";
import { A11y, Navigation, Pagination, Scrollbar } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
export default {
  name: "ButtonPillsContainer",
  components: { ButtonPill, Swiper, SwiperSlide },
  props: {
    cat: {
      type: Object,
      required: true,
    },
    selectedChild: {
      type: Number,
      required: true,
    },
  },
  computed: {
    slidesPerView() {
      if(this.currentWidth == 0){
        this.updateSize()
      }
      return this.$breakpoints("buttons", this.currentWidth);
    },
  },
  data() {
    return {
      currentWidth: 0,
    };
  },
  mounted() {
    this.updateSize();
    window.addEventListener("resize", this.updateSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateSize);
  },
  methods: {
    updateSize() {
      this.currentWidth = window.innerWidth;
    },
    selectChild(index) {
      this.$emit("selectChild", index);
    },
    onSwiper(swiper) {},
    onSlideChange() {},
    onSwiperReachEnd(swiper) {},
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
};
</script>
<style scoped lang="scss">
.btn-outline-pill {
  margin-right: 1em;
  margin-bottom: 0.5em;
  border-radius: 20px;
  color: #fff;
  width: 100%;
  &:last-child {
    max-resolution: 0;
  }
}
</style>
